import { j as e } from "./jsx-runtime-3tyXYecC.mjs";
import { f as r } from "./index-LyFokDcn.mjs";
import n, { useState as y, useRef as k, useEffect as N } from "react";
import { A as C } from "./avatar-1JHdkfls.mjs";
import { C as V } from "./cropper-BJfqTv_0.mjs";
import { F as X } from "./file-dropper-iCPDh7on.mjs";
import { F as B } from "./flex-Cc3osQLf.mjs";
import { H as Y } from "./headline-DF2GOgMa.mjs";
import { S as ee } from "./index-CoZFka0j.mjs";
import { S as p } from "./standard-modal-CYPriMwW.mjs";
import { m as re } from "./tss-DN0acMKN.mjs";
import { M as v, d as w } from "./constants-CnFYFetN.mjs";
import { T } from "./text-button-yPCa43NP.mjs";
import { B as _ } from "./button-CUHBhgeQ.mjs";
import { L as te } from "./loader-CJQkrVUR.mjs";
import { I as ie } from "./icon-button-BxDvkq_l.mjs";
import { D as oe } from "./divider-Dq5lrAFK.mjs";
const D = (t) => n.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 100 100", width: "100", height: "100" }, t),
  n.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    n.createElement("path", { d: "M50,0 C77.6125,0 100,22.3875 100,50 C100,77.6125 77.6125,100 50,100 C22.3875,100 0,77.6125 0,50 C0,22.3875 22.3875,0 50,0 Z M50,20.8333333 C39.6625,20.8333333 31.25,29.2458333 31.25,39.5833333 C31.25,49.9208333 39.6625,58.3333333 50,58.3333333 C60.3375,58.3333333 68.75,49.9208333 68.75,39.5833333 C68.75,29.2458333 60.3375,20.8333333 50,20.8333333 Z M50,91.6666667 C60.75,91.6666667 70.5291667,87.5416667 77.9291667,80.8291667 C74.4041667,72.6708333 63.2666667,66.6666667 50,66.6666667 C36.7333333,66.6666667 25.5958333,72.6708333 22.0708333,80.8291667 C29.4708333,87.5416667 39.25,91.6666667 50,91.6666667 Z" })
  )
);
D.displayName = "PersonCircle100x100";
const Z = (t) => n.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 144 144", width: "144", height: "144" }, t),
  n.createElement("path", { d: "M72 0C32.238 0 0 32.238 0 72C0 111.762 32.238 144 72 144C111.762 144 144 111.762 144 72C144 32.238 111.762 0 72 0ZM72 29.9997C86.886 29.9997 99 42.1137 99 56.9997C99 71.8857 86.886 83.9997 72 83.9997C57.114 83.9997 45 71.8857 45 56.9997C45 42.1137 57.114 29.9997 72 29.9997ZM72 132C56.52 132 42.4381 126.06 31.7821 116.394C36.8581 104.646 52.8959 96.0003 72 96.0003C91.1041 96.0003 107.142 104.646 112.218 116.394C101.562 126.06 87.48 132 72 132Z" })
);
Z.displayName = "PersonCircle144x144";
const H = (t) => n.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 24 24", width: "24", height: "24" }, t),
  n.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    n.createElement(
      "g",
      { fillRule: "nonzero" },
      n.createElement("path", { d: "M792,1591 C785.373,1591 780,1596.373 780,1603 C780,1609.627 785.373,1615 792,1615 C798.627,1615 804,1609.627 804,1603 C804,1596.373 798.627,1591 792,1591 Z M792,1596 C794.481,1596 796.5,1598.019 796.5,1600.5 C796.5,1602.981 794.481,1605 792,1605 C789.519,1605 787.5,1602.981 787.5,1600.5 C787.5,1598.019 789.519,1596 792,1596 Z M792,1613 C789.42,1613 787.073,1612.01 785.297,1610.399 C786.143,1608.441 788.816,1607 792,1607 C795.184,1607 797.857,1608.441 798.703,1610.399 C796.927,1612.01 794.58,1613 792,1613 Z", transform: "translate(-780 -1591)" })
    )
  )
);
H.displayName = "PersonCircle24x24";
const Q = (t) => n.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 40 40", width: "40", height: "40" }, t),
  n.createElement("path", { d: "M20 0C8.955 0 0 8.955 0 20C0 31.045 8.955 40 20 40C31.045 40 40 31.045 40 20C40 8.955 31.045 0 20 0ZM20 8.33325C24.135 8.33325 27.5 11.6983 27.5 15.8333C27.5 19.9683 24.135 23.3333 20 23.3333C15.865 23.3333 12.5 19.9683 12.5 15.8333C12.5 11.6983 15.865 8.33325 20 8.33325ZM20 36.6667C15.7 36.6667 11.7884 35.0165 8.82837 32.3315C10.2384 29.0682 14.6933 26.6667 20 26.6667C25.3067 26.6667 29.7616 29.0682 31.1716 32.3315C28.2116 35.0165 24.3 36.6667 20 36.6667Z" })
);
Q.displayName = "PersonCircle40x40";
const A = (t) => n.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 10 12", width: "10", height: "12" }, t),
  n.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    n.createElement(
      "g",
      null,
      n.createElement("path", { d: "M1260,521 L1268,521 L1267.4475,528.049938 C1267.42089,528.582147 1266.98162,529 1266.44875,529 L1261.55125,529 C1261.01837,529 1260.57911,528.582147 1260.5525,528.049938 L1260,521 Z M1261,519 C1261,517.89543 1261.89543,517 1263,517 L1265,517 C1266.10457,517 1267,517.89543 1267,519 L1268.5,519 C1268.77614,519 1269,519.22386 1269,519.5 C1269,519.77614 1268.77614,520 1268.5,520 L1259.5,520 C1259.22386,520 1259,519.77614 1259,519.5 C1259,519.22386 1259.22386,519 1259.5,519 L1261,519 Z M1263,518 C1262.44771,518 1262,518.44772 1262,519 L1266,519 C1266,518.44772 1265.55228,518 1265,518 L1263,518 Z", transform: "translate(-1259 -517)" })
    )
  )
);
A.displayName = "TrashCan10x12";
const M = [".bmp", ".gif", ".jpeg", ".jpg", ".png"], ne = re()(({ borderRadiuses: t, mode: c, palette: a, spacing: o, typography: s }) => ({
  wrapper: {
    color: c === v.Dye ? w.main : a.gray[800],
    display: "flex",
    fill: c === v.Dye ? w.main : a.gray[500],
    justifyContent: "space-evenly",
    width: r.ifFeature("encore", "720px")
  },
  cropperWrapper: {
    alignItems: "center",
    maxWidth: "248px",
    minHeight: "248px"
  },
  previews: {
    display: "flex",
    flexDirection: r.ifFeature("encore", "row", "column"),
    gap: r.ifFeature("encore", o(2.5), o(2)),
    /* @startCleanup encore */
    "& > svg": {
      alignSelf: r.ifFeature("encore", void 0, "center")
    }
    /* @endCleanup encore */
  },
  preview: {
    /* @startCleanup encore */
    alignSelf: r.ifFeature("encore", void 0, "center"),
    /* @endCleanup encore */
    outline: c === v.Dye ? `2px solid ${w.main}` : void 0,
    overflow: "hidden"
  },
  previewSmall: {
    borderRadius: r.ifFeature("encore", t[200], "50%"),
    height: r.ifFeature("encore", "32px", "24px"),
    width: r.ifFeature("encore", "32px", "24px")
  },
  previewMedium: {
    borderRadius: r.ifFeature("encore", t[300], "50%"),
    height: r.ifFeature("encore", "56px", "40px"),
    width: r.ifFeature("encore", "56px", "40px")
  },
  previewLarge: {
    borderRadius: r.ifFeature("encore", t[500], "50%"),
    height: r.ifFeature("encore", "96px", "100px"),
    width: r.ifFeature("encore", "96px", "100px")
  },
  /* @startCleanup encore */
  previewTitle: {
    borderBottom: `1px solid ${a.gray[600]}`,
    lineHeight: s.medium.lineHeight,
    width: "120px"
  },
  /* @endCleanup encore */
  blankState: {
    alignItems: r.ifFeature("encore", "center"),
    backgroundColor: c === v.Dye ? w.lightest : a.gray[100],
    borderRadius: r.ifFeature("encore", t[200]),
    boxSizing: "border-box",
    display: r.ifFeature("encore", "flex"),
    flexDirection: r.ifFeature("encore", "column"),
    height: "248px",
    justifyContent: r.ifFeature("encore", "center"),
    /* @startCleanup encore */
    padding: r.ifFeature("encore", "0px", "40px 8px 20px"),
    /* @endCleanup encore */
    rowGap: r.ifFeature("encore", o(3)),
    width: "248px",
    "& > svg": {
      display: "block",
      margin: `0 auto ${o(3)}`
    }
  },
  blankStateText: {
    fontSize: s.small.fontSize,
    lineHeight: s.small.lineHeight,
    padding: `0 ${o(2)}`,
    textAlign: "center"
  },
  fileActions: {
    columnGap: r.ifFeature("encore", o(1)),
    display: r.ifFeature("encore", "flex"),
    justifyContent: r.ifFeature("encore", "center"),
    marginTop: o(2),
    textAlign: "center"
  },
  hiddenFileInput: {
    display: "none"
  }
})), z = (t, c, a) => {
  const o = t[0], s = new FileReader();
  s.addEventListener(
    "load",
    () => {
      s.result && (c(void 0), a(s.result));
    },
    !1
  ), o && s.readAsDataURL(o);
}, ae = (t, c, a, o) => {
  const s = t.target;
  if (s.files) {
    const u = s.files[0], f = u.name.slice(u.name.lastIndexOf(".")).toLowerCase();
    if (M.includes(f))
      z([u], c, a);
    else {
      const g = window.jQuery ? $.__("This file type is not allowed:") : "This file type is not allowed:";
      o(`${g} ${f}`);
    }
  }
};
function _e({
  biId: t,
  imageAlt: c,
  imageSrc: a,
  initialCropBoxCoords: o,
  loading: s,
  open: u,
  onCancel: f,
  onDelete: g,
  onSave: G,
  processing: j
}) {
  const { classes: i, cx: m } = ne(), [R, h] = y(o), [d, x] = y(a), [S, b] = y(""), E = k(null), P = k(null);
  N(() => {
    x(a);
  }, [a]), N(() => {
    h(o);
  }, [o]);
  const O = (l) => {
    h(l);
  }, I = () => {
    var l;
    x(void 0), h(void 0), (l = E.current) == null || l.reset();
  }, L = () => {
    d ? G(d, R) : g();
  }, F = () => {
    h(void 0), x(void 0), f();
  }, W = window.jQuery ? $.__("Choose Photo") : "Choose Photo", U = window.jQuery ? $.__("Change Photo") : "Change Photo", q = window.jQuery ? $.__("Add Photo") : "Add Photo", J = window.jQuery ? $.__("Edit Photo") : "Edit Photo", K = a ? J : q;
  return /* @__PURE__ */ e.jsx(p, { isOpen: u, isProcessing: j, onRequestClose: F, children: /* @__PURE__ */ e.jsx(
    p.Body,
    {
      renderFooter: /* @__PURE__ */ e.jsx(
        p.Footer,
        {
          actions: r.ifFeature(
            "encore",
            [
              /* @__PURE__ */ e.jsx(
                T,
                {
                  "data-bi-id": t ? `${t}-cancel` : void 0,
                  onClick: F,
                  type: "button",
                  children: window.jQuery ? $.__("Cancel") : "Cancel"
                },
                "cancel"
              ),
              /* @__PURE__ */ e.jsx(_, { "data-bi-id": t ? `${t}-save` : void 0, onClick: L, type: "button", children: window.jQuery ? $.__("Save") : "Save" }, "save")
            ],
            [
              /* @__PURE__ */ e.jsx(_, { "data-bi-id": t ? `${t}-save` : void 0, onClick: L, type: "button", children: window.jQuery ? $.__("Save") : "Save" }, "save"),
              /* @__PURE__ */ e.jsx(
                T,
                {
                  "data-bi-id": t ? `${t}-cancel` : void 0,
                  onClick: F,
                  type: "button",
                  children: window.jQuery ? $.__("Cancel") : "Cancel"
                },
                "cancel"
              )
            ]
          )
        }
      ),
      renderHeader: /* @__PURE__ */ e.jsx(p.Header, { title: K }),
      size: r.ifFeature("encore", "medium", "small"),
      children: /* @__PURE__ */ e.jsxs(
        p.Constraint,
        {
          spacingOverrides: {
            top: p.Constraint.Spacing.LARGE,
            bottom: p.Constraint.Spacing.LARGE
          },
          children: [
            s ? /* @__PURE__ */ e.jsx(te, {}) : /* @__PURE__ */ e.jsx(
              X,
              {
                acceptedTypes: M,
                onFileDrop: (l) => z(l, h, x),
                children: /* @__PURE__ */ e.jsxs("form", { className: i.wrapper, ref: E, children: [
                  /* @__PURE__ */ e.jsxs(B, { alignItems: r.ifFeature("encore", "center"), flex: r.ifFeature("encore", 1), flexDirection: "column", children: [
                    /* @__PURE__ */ e.jsx("div", { className: i.cropperWrapper, children: d ? /* @__PURE__ */ e.jsx(
                      V,
                      {
                        biId: t ? `${t}-cropper` : void 0,
                        imageAlt: c,
                        imageSrc: d,
                        initialCropBoxCoords: R,
                        onChange: O,
                        previewSelector: `.${i.previews} > div`
                      }
                    ) : /* @__PURE__ */ e.jsxs("div", { className: i.blankState, children: [
                      r.ifFeature("encore", /* @__PURE__ */ e.jsx(C, { size: 128 }), /* @__PURE__ */ e.jsx(Z, {})),
                      /* @__PURE__ */ e.jsx("p", { className: i.blankStateText, children: window.jQuery ? $.__("Drop file here to upload...") : "Drop file here to upload..." })
                    ] }) }),
                    /* @__PURE__ */ e.jsxs("div", { className: i.fileActions, children: [
                      /* @__PURE__ */ e.jsx(
                        "input",
                        {
                          accept: M.join(","),
                          className: i.hiddenFileInput,
                          onChange: (l) => ae(l, h, x, b),
                          ref: P,
                          type: "file"
                        }
                      ),
                      /* @__PURE__ */ e.jsx(
                        _,
                        {
                          color: r.ifFeature("encore", "secondary", "primary"),
                          "data-bi-id": t ? `${t}-choose-photo` : void 0,
                          onClick: () => {
                            var l;
                            return (l = P.current) == null ? void 0 : l.click();
                          },
                          processing: j,
                          type: "button",
                          variant: r.ifFeature("encore", "contained", "outlined"),
                          children: d ? U : W
                        }
                      ),
                      d && /* @__PURE__ */ e.jsx(
                        ie,
                        {
                          ariaLabel: window.jQuery ? $.__("Remove photo") : "Remove photo",
                          color: r.ifFeature("encore", "primary", "secondary"),
                          "data-bi-id": t ? `${t}-remove-photo` : void 0,
                          icon: r.ifFeature("encore", "trash-can-regular", /* @__PURE__ */ e.jsx(A, {})),
                          onClick: I,
                          processing: j,
                          type: "button",
                          variant: "outlined"
                        }
                      )
                    ] })
                  ] }),
                  r.ifFeature(
                    "encore",
                    /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
                      /* @__PURE__ */ e.jsx(oe, { color: "neutral-extra-weak", marginLeft: 5, marginRight: 5, orientation: "vertical" }),
                      /* @__PURE__ */ e.jsxs(B, { flex: 1, flexDirection: "column", rowGap: 2, children: [
                        /* @__PURE__ */ e.jsx(Y, { color: "neutral-strong", size: "small", children: window.jQuery ? $.__("Preview") : "Preview" }),
                        /* @__PURE__ */ e.jsx("div", { className: i.previews, children: d ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
                          /* @__PURE__ */ e.jsx("div", { className: m(i.preview, i.previewLarge) }),
                          /* @__PURE__ */ e.jsx("div", { className: m(i.preview, i.previewMedium) }),
                          /* @__PURE__ */ e.jsx("div", { className: m(i.preview, i.previewSmall) })
                        ] }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
                          /* @__PURE__ */ e.jsx(C, { size: 96 }),
                          /* @__PURE__ */ e.jsx(C, { size: 56 }),
                          /* @__PURE__ */ e.jsx(C, { size: 32 })
                        ] }) })
                      ] })
                    ] }),
                    /* @__PURE__ */ e.jsxs("div", { className: i.previews, children: [
                      /* @__PURE__ */ e.jsx("p", { className: i.previewTitle, children: window.jQuery ? $.__("Preview") : "Preview" }),
                      d ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
                        /* @__PURE__ */ e.jsx("div", { className: m(i.preview, i.previewLarge) }),
                        /* @__PURE__ */ e.jsx("div", { className: m(i.preview, i.previewMedium) }),
                        /* @__PURE__ */ e.jsx("div", { className: m(i.preview, i.previewSmall) })
                      ] }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
                        /* @__PURE__ */ e.jsx(D, {}),
                        /* @__PURE__ */ e.jsx(Q, {}),
                        /* @__PURE__ */ e.jsx(H, {})
                      ] })
                    ] })
                  )
                ] })
              }
            ),
            /* @__PURE__ */ e.jsx(ee, { message: S, onDismiss: () => b(""), show: !!S, type: "error" })
          ]
        }
      )
    }
  ) });
}
export {
  _e as P
};
//# sourceMappingURL=photo-upload-modal-CYMfbUJQ.mjs.map
